import { getCheckboxValues } from '../core/cookie-manager';
import savePreferences from '../preferences/save-preferences';
import managerServices from '../manager/manager-services';
import type { GdprAction } from '../types';

const modSavePreferences = new savePreferences();
const modManagerServices = new managerServices();

export default class cookieActions {

    /**
     * Handle a GDPR action (accept, decline, save-customize)
     */
    handleAction(action: GdprAction, parentId: string): void {
        const currentUrl: string = window.location.href;

        const parentEl = document.getElementById(parentId);

        const data: Record<string, any> = {
            action: action,
            html: parentEl?.outerHTML ?? '',
            current_url: currentUrl,
        };

        const inputCheckbox = document.querySelectorAll<HTMLInputElement>('.checkbox-gdpr');

        switch (action) {
            case 'accept':
                inputCheckbox.forEach((checkbox) => { checkbox.checked = true; });
                modSavePreferences.save(
                    this.findActionButton(action, parentId),
                    data,
                    () => modManagerServices.checkPreferences()
                );
                break;

            case 'decline':
                inputCheckbox.forEach((checkbox) => { checkbox.checked = false; });
                modSavePreferences.save(
                    this.findActionButton(action, parentId),
                    data,
                    () => modManagerServices.checkPreferences()
                );
                break;

            case 'save-customize':
                const checkboxValues = getCheckboxValues('.checkbox-gdpr');
                data['checkbox'] = JSON.stringify(
                    checkboxValues.map((item) => ({ [item.type]: item.checked ? 1 : 0 }))
                );
                modSavePreferences.save(
                    this.findActionButton(action, parentId),
                    data,
                    () => modManagerServices.checkPreferences()
                );
                break;
        }
    }

    private findActionButton(action: string, parentId: string): HTMLButtonElement {
        return document.querySelector<HTMLButtonElement>(
            `.btn-dialog-gdpr[data-action="${action}"][data-parent="${parentId}"]`
        ) as HTMLButtonElement;
    }
}
